import React from 'react';

import {type RunsLinePlotConfig} from '../types';
import {
  type AxisScaffolding,
  AxisSections,
  DROPDOWN_FLEX_GROW_STYLE,
  X_AXIS_DROPDOWN_RESULT_LIMIT,
  type XAxisChangeHandler,
} from './AxisSections';
import {HistoryKeysXAxisPicker} from './HistoryKeysXAxisPicker';
import {HistoryKeysYAxisPicker} from './HistoryKeysYAxisPicker';
import {useHistoryKeysAxisChoices} from './useHistoryKeysAxisChoices';

type HistoryKeysAxisSectionsProps = AxisScaffolding & {
  config: RunsLinePlotConfig;
  xAxis: string;
  isSingleRun: boolean;
  entityName: string;
  projectName: string;
  onXAxisChange: XAxisChangeHandler;
  updateConfig: (config: RunsLinePlotConfig) => void;
};

/**
 * History-keys x/y axis pickers
 *
 * The key-info context read lives here rather than in `EditDataTab` so it only
 * runs when this component is mounted — callers gate on the picker variant and
 * mount the metric-search variant instead when the ngw flag is on.
 */
export const HistoryKeysAxisSections = ({
  xAxisRange,
  xAxisTitle,
  yAxisRange,
  yAxisTitle,
  onResetXAxis,
  config,
  xAxis,
  isSingleRun,
  entityName,
  projectName,
  onXAxisChange,
  updateConfig,
}: HistoryKeysAxisSectionsProps) => {
  const {keyInfo, keyTypes, xAxisChoices, yAxisChoices, fromV2} =
    useHistoryKeysAxisChoices({
      config,
      xAxis,
      isSingleRun,
      entityName,
      projectName,
    });

  return (
    <AxisSections
      xAxisRange={xAxisRange}
      xAxisTitle={xAxisTitle}
      yAxisRange={yAxisRange}
      yAxisTitle={yAxisTitle}
      onResetXAxis={onResetXAxis}
      xPicker={
        <HistoryKeysXAxisPicker
          keyInfoKeys={keyInfo.keys}
          xAxisChoices={xAxisChoices}
          fromV2={fromV2}
          xAxis={xAxis}
          resultLimit={X_AXIS_DROPDOWN_RESULT_LIMIT}
          style={DROPDOWN_FLEX_GROW_STYLE}
          onChange={onXAxisChange}
        />
      }
      yPicker={
        <HistoryKeysYAxisPicker
          keyInfo={keyInfo}
          keyTypes={keyTypes}
          yAxisChoices={yAxisChoices}
          config={config}
          updateConfig={updateConfig}
        />
      }
    />
  );
};
